import Helpers from '@helpers';
import * as React from 'react';
import OverlayHelper from '../overlay/overlay';
import { NationalCodeModalHelper, State } from './model';

const NationalCodeModalHelper: NationalCodeModalHelper = {};

class NationalCodeModal extends React.Component<{}, State> {

    private onFinished;
    constructor(props) {
        super(props);

        this.state = this.getInitialState();
    }

    public componentDidMount() {
        NationalCodeModalHelper.openNationalCodeModal = this.openModal;
    }

    public render() {
        OverlayHelper.onClick = this.closeModal;
        return (
            <div className='modal national-code-modal address-modal'
                style={{ display: this.getModalDisplayStyle() }}
            >
                <div className='fa fa-remove close-windows' onClick={this.closeModal} />
                <div className='address-form'>
                    <div className='form-row'>
                        <div className="w-100">
                            <p className="text-fa-h4 mb-2">
                                <span className="font-weight-medium text-fa-h3 mb-3 d-inline-block">
                                    کاربر گرامی
                                </span><br />
                                لطفا جهت ادامه فرآیند خرید، شماره ملی خود را وارد کنید:
                            </p>
                            <div className="w-100">
                                <input
                                    type='text'
                                    className='form-control w-100 border border-light text-left text-fa-h4 text-gray'
                                    onChange={this.onNationalCodeChanged}
                                    value={this.state.nationalCode}
                                />
                                <div className='text-fa-h6 text-red mt-1'
                                    style={{ display: this.getErrorDisplayStyle(this.state.nationalCodeErrorMessage) }}
                                >
                                    {this.state.nationalCodeErrorMessage}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{'textAlign':'left'}}>
                        <button className='btn btn-red text-fa-h3'
                            onClick={this.onSubmit}
                        >
                            ادامه
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private getErrorDisplayStyle = errorMessage =>
        errorMessage &&
            errorMessage.length > 0 ? 'block' : 'none'

    private getInitialState = (): State => ({
        visible: false,
        nationalCode: '',
        nationalCodeErrorMessage: ''
    })

    private onNationalCodeChanged = event => {
        this.setState({
            nationalCode: event.target.value,
            nationalCodeErrorMessage: null
        });
    }

    private openModal = (onFinished) => {
        this.onFinished = onFinished;
        OverlayHelper.onClick = this.closeModal;
        OverlayHelper.showOverlay();
        this.setState({
            visible: true
        });
    }

    private clearModal = () => {
        this.setState(this.getInitialState());
    }

    private getModalDisplayStyle = () => this.state.visible ? 'block' : 'none';

    private validateForm = () => {
        var nationalCodeErrorMessage = this.isValidIranianNationalCode(this.state.nationalCode) ?
            '' :
            'لطفا کد ملی را بدرستی وارد نمائید.';

        const hasError =
            nationalCodeErrorMessage.length > 0;

        return {
            nationalCodeErrorMessage,
            hasError
        };
    }

    private isValidIranianNationalCode= input=> {
        if (!/^\d{10}$/.test(input))
            return false;

        var output = input.split('').map(function (item) {
            return parseInt(item, 10);
        });
        if (Math.max.apply(Math, output) === Math.min.apply(Math, output)) {
            return false;
        }

        var check = +input[9];
        var sum = Array(9).fill(0).map((_, i) => +input[i] * (10 - i)).reduce((x, y) => x + y);
        var md = sum % 11;
        return sum !== 0 && ((md < 2 && check == md) || (md >= 2 && check + md == 11));
    }

    private onSubmit = e => {
        const errors = this.validateForm();

        if (errors.hasError) {
            const nationalCodeErrorMessage = errors.nationalCodeErrorMessage;

            this.setState({
                ...this.state,
                nationalCodeErrorMessage
            });

            e.preventDefault();
            return false;
        }

        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.addNationalCodeAsync(
            this.state.nationalCode).then(_ => {
                this.closeModal();
                this.onFinished();
            }).always(_ => {
                Helpers.LoadingHelper.hideLoading();
            });

        e.preventDefault();
        return false;
    }

    private closeModal = () => {
        this.setState({
            visible: false
        });

        OverlayHelper.hideOverlay();
        this.clearModal();
    }
}

Helpers.ReactHelper.createReactElement('NationalCodeModal', NationalCodeModal);

export default NationalCodeModalHelper;
